import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { ArrowLeft, Droplet, Music, HandHeart, Bus } from 'lucide-react';
export function SaintLuciaPage() {
  return <div className="min-h-screen font-sans" style={{
    backgroundColor: '#0D121D'
  }} data-id="element-502">
      <Header data-id="element-503" />

      <main className="pt-32 pb-24 min-h-screen" data-id="element-504">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-505">
          <a href="/" className="inline-flex items-center text-slate-300 hover:text-white transition-colors mb-12" data-id="element-506">
            <ArrowLeft className="w-5 h-5 mr-2" data-id="element-507" />
            Back to Home
          </a>

          <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-508">
            <div className="mb-12 flex justify-center" data-id="element-509">
              <img src="https://cdn.magicpatterns.com/uploads/f93p7hGFgnSLSjPJ4odna3/Twice_Bourne_Logo-08.png" alt="Twice Bourne Holdings LTD Logo" className="max-w-md w-full h-auto" data-id="element-510" />
            </div>

            <h1 className="text-4xl md:text-5xl font-bold text-white mb-6" data-id="element-511">
              Twice Bourne Holdings LTD
            </h1>
            <p className="text-xl text-slate-300" data-id="element-512">
              Building prosperity in Saint Lucia through diverse ventures
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-513">
            {/* Buy Natural Honey */}
            <a href="/honey" className="group bg-white/5 backdrop-blur rounded-2xl border border-slate-700/50 hover:border-amber-400/50 transition-colors p-8 flex flex-col" data-id="element-514">
              <div className="w-12 h-12 rounded-full bg-amber-400/20 flex items-center justify-center mb-6 text-amber-300" data-id="element-515">
                <Droplet className="w-6 h-6" data-id="element-516" />
              </div>
              <h3 className="text-xl font-bold text-white mb-3 group-hover:text-amber-300 transition-colors" data-id="element-517">
                Buy Natural Honey Produced in Saint Lucia
              </h3>
              <p className="text-slate-300 flex-grow mb-4" data-id="element-518">
                Pure, raw honey harvested from our own apiaries in Saint Lucia.
                Bottled with care and ready for delivery to your doorstep.
              </p>
              <span className="text-sm text-amber-300 font-medium" data-id="element-519">
                Learn More →
              </span>
            </a>

            {/* Artist Launch - Honorable Music */}
            <a href="/honorable-music" className="group bg-white/5 backdrop-blur rounded-2xl border border-slate-700/50 hover:border-slate-500 transition-colors p-8 flex flex-col" data-id="element-520">
              <div className="w-12 h-12 rounded-full bg-white/10 flex items-center justify-center mb-6 text-white" data-id="element-521">
                <Music className="w-6 h-6" data-id="element-522" />
              </div>
              <div className="inline-block px-3 py-1 rounded-full bg-green-600/20 text-green-400 text-xs font-medium mb-3 self-start" data-id="element-523">
                Artist Launch
              </div>
              <h3 className="text-xl font-bold text-white mb-3 group-hover:text-green-400 transition-colors" data-id="element-524">
                Honorable Music
              </h3>
              <p className="text-slate-300 flex-grow mb-4" data-id="element-525">
                New Soca Artist from Saint Lucia. Start a vibe and book a
                performance with two hit singles making waves.
              </p>
              <span className="text-sm text-green-400 font-medium" data-id="element-526">
                Explore the Artist →
              </span>
            </a>

            {/* Anse Canot Community Outreach Foundation */}
            <a href="/anse-canot" className="group bg-white/5 backdrop-blur rounded-2xl border border-slate-700/50 hover:border-emerald-400/50 transition-colors p-8 flex flex-col" data-id="element-527">
              <div className="w-12 h-12 rounded-full bg-emerald-400/20 flex items-center justify-center mb-6 text-emerald-300" data-id="element-528">
                <HandHeart className="w-6 h-6" data-id="element-529" />
              </div>
              <h3 className="text-xl font-bold text-white mb-3 group-hover:text-emerald-300 transition-colors" data-id="element-530">
                Anse Canot Community Outreach Foundation
              </h3>
              <p className="text-slate-300 flex-grow mb-4" data-id="element-531">
                Empowering kids in our community with technology and digital
                skills to build brighter futures.
              </p>
              <span className="text-sm text-emerald-300 font-medium" data-id="element-532">
                Learn More →
              </span>
            </a>

            {/* Scheduled Bus Route Service - Coming Soon */}
            <div className="bg-white/5 backdrop-blur rounded-2xl border border-slate-700/50 p-8 flex flex-col opacity-70" data-id="element-533">
              <div className="w-12 h-12 rounded-full bg-white/10 flex items-center justify-center mb-6 text-white" data-id="element-534">
                <Bus className="w-6 h-6" data-id="element-535" />
              </div>
              <div className="inline-block px-3 py-1 rounded-full bg-slate-700/50 text-slate-400 text-xs font-medium mb-3 self-start" data-id="element-536">
                Coming Soon
              </div>
              <h3 className="text-xl font-bold text-white mb-3" data-id="element-537">
                Scheduled Bus Route Service
              </h3>
              <p className="text-slate-300 flex-grow" data-id="element-538">
                Reliable transportation across Saint Lucia. Scheduled bus routes
                for daily commuters, camps, churches, schools and events.
              </p>
            </div>
          </div>
        </div>
      </main>

      <Footer data-id="element-539" />
    </div>;
}